<template>
  <div class="space-y-6">
    <div class="flex items-start justify-between gap-4">
      <div>
        <h2 class="flex items-center gap-2 text-2xl font-bold text-gray-800">
          Discord-Server je Micro-Credential
          <BaseInfoIcon :text="ERKLAERUNG.discordTab" label="Discord-Server je Micro-Credential" :oben="false" fixiert />
        </h2>
        <!-- Eine Regel, die keine Oberfläche erzwingt: sichtbar die
             Kurzform, das Warum am Icon (30.09., Simon: redundanten Text in
             Tooltips). -->
        <p class="mt-1 flex items-center gap-1.5 text-xs text-gray-500 semester-regel">
          {{ SEMESTER_REGEL.kurz }}
          <BaseInfoIcon
            :text="SEMESTER_REGEL.kategorieName"
            label="Semesterregel"
            :oben="false"
            fixiert
          />
        </p>
      </div>
      <BaseButton variant="cancel" @click="ladeAlles" :disabled="loading">
        Neu laden
      </BaseButton>
    </div>

    <div v-if="errorMessage" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
      {{ errorMessage }}
    </div>
    <div v-if="successMessage" class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
      {{ successMessage }}
    </div>

    <!-- Der Ausfall wird AUSGESCHRIEBEN, nicht geschluckt — und mit dem
         richtigen Satz: 401 ist kein „nicht erreichbar" (Falle vom 24.08.). -->
    <p v-if="botFehler" class="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded px-3 py-2">
      {{ DISCORD_SERVER[botFehler] }}
    </p>
    <p v-else-if="guilds.length" class="text-xs text-gray-500">
      Bot auf {{ guilds.length }} Server(n): {{ guilds.map((g) => g.name).join(', ') }}
    </p>

    <div v-if="loading" class="text-center py-8">
      <p class="text-gray-600">Lade Credentials…</p>
    </div>

    <div v-else class="bg-white rounded-lg shadow overflow-hidden">
      <table class="min-w-full">
        <thead class="bg-gray-100">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">ID</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Credential</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Discord-Server</th>
            <th class="px-6 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider">Aktion</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="zeile in zeilen" :key="zeile.id" class="discord-zuordnung-zeile hover:bg-gray-50">
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ zeile.id }}</td>
            <td class="px-6 py-4 whitespace-nowrap">
              <div class="text-sm font-medium text-gray-900">{{ zeile.name }}</div>
              <!-- An der ID aufgehaengt, nicht am Namen: bei Handeingabe gibt
                   es keinen Namen, und die gespeicherte ID blieb dann unsichtbar
                   (Handprobe H3b, 18.09.). Die ID entscheidet, der Name ist
                   Anzeige -- also zeigt die Zeile die ID immer. -->
              <div v-if="zeile.gespeicherteId" class="text-xs text-gray-500">
                gespeichert: {{ zeile.gespeicherterName || '?' }} ({{ zeile.gespeicherteId }})
              </div>
            </td>
            <td class="px-6 py-4 min-w-[20rem]">
              <!-- ⚠️ Der :key ist Pflicht, kein Stil (gemessen 18.09. mit
                   Bot 200: „0 Selects"). Die Tabelle steht, sobald die
                   Credentials da sind — der Bot-Aufruf kommt danach, und
                   GuildWahl entscheidet in data() EINMAL zwischen Liste und
                   Handeingabe: ohne den key blieb jede Zeile bei der
                   Handeingabe, obwohl die Serverliste längst geladen war.
                   Seit 01.10. zählt der Zähler bei BEIDEN Listen hoch
                   (bekannte Server, dann Bot).
                   Dieselbe Falle, derselbe Riegel wie im Credential-Dialog
                   (MicroCredentialList.vue). -->
              <GuildWahl
                :key="`guildwahl-${zeile.id}-${guildsGeladen}`"
                :modelValue="zeile.entwurf.id"
                :guildName="zeile.entwurf.name"
                :guilds="guilds"
                :bekannte="bekannte"
                :botFehler="botFehler"
                @gewaehlt="(w) => setze(zeile, w)"
              />
              <!-- Zulässig, aber sichtbar: derselbe Server an mehreren
                   Credentials. Gezählt über die GESPEICHERTEN Werte, nicht
                   über die Entwürfe. -->
              <p v-if="mehrfach.has(zeile.gespeicherteId)" class="mt-1 text-xs text-amber-800">
                {{ DISCORD_SERVER.mehrfach }}
              </p>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-right text-sm">
              <!-- Speichern ist der PATCH (01.10.). Ersetzt oder löst er einen
                   bestehenden Server, fragt erst der Dialog unten. Ohne
                   Änderung gesperrt -- eine Begründung per Tooltip am
                   disabled-Knopf erschiene nie (Falle vom 08.08.), und
                   „nichts geändert" braucht keine. -->
              <BaseButton
                class="px-3 py-1"
                :disabled="!zeile.geaendert || zeile.speichert"
                @click="speichern(zeile)"
              >
                Speichern
              </BaseButton>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="zeilen.length === 0" class="text-center py-8 text-gray-500">
        Keine Micro-Credentials vorhanden.
      </div>
    </div>

    <!-- Nur beim ERSETZEN oder LÖSEN eines bestehenden Servers
         (serverwechselBrauchtBestaetigung): ein Satz, der die Entscheidung
         trägt, das Warum am Icon. Abbrechen schickt nichts. -->
    <ConfirmModal
      :isOpen="!!bestaetigung"
      :title="SERVERWAHL.titel"
      :confirmLabel="bestaetigung && bestaetigung.entwurf.id ? SERVERWAHL.knopfErsetzen : SERVERWAHL.knopfLoesen"
      confirmVariant="primary"
      cancelLabel="Abbrechen"
      @confirm="bestaetigt"
      @cancel="bestaetigung = null"
    >
      <span v-if="bestaetigung" class="inline-flex items-start gap-1.5 bestaetigung-satz">
        <span>{{ bestaetigungsSatz }}</span>
        <BaseInfoIcon :text="ERKLAERUNG.serverErsetzen" label="Was mit den Nachrichten geschieht" fixiert />
      </span>
    </ConfirmModal>
  </div>
</template>

<script>
import { getAllMicroCredentials, updateMicroCredential } from '@/api/admin';
import BaseButton from '@/BaseComponents/BaseButton.vue';
import BaseInfoIcon from '@/BaseComponents/BaseInfoIcon.vue';
import ConfirmModal from '@/BaseComponents/ConfirmModal.vue';
import GuildWahl from './GuildWahl.vue';
import {
  DISCORD_SERVER,
  SEMESTER_REGEL,
  SERVERWAHL,
  ladeBekannteServer,
  ladeDiscordServer,
  serverwechselBrauchtBestaetigung,
} from '@/async-sessions/discordServer';
import { ERKLAERUNG } from '@/async-sessions/erklaerungen';

/**
 * Der Admin-Tab „Discord-Server": je Credential ein aktiver Server.
 *
 * Seit 01.10. ist der Wechsel ein einfacher PATCH -- kein Anheften, keine
 * Vorschau, keine Zuordnungsansicht. Zuordnungen gelten immer für den
 * aktiven Server; Nachrichten anderer Server bleiben gespeichert und sind
 * nach einem Rückwechsel wieder da. Beim Ersetzen oder Lösen eines
 * bestehenden Servers fragt ein ConfirmModal mit EINEM Satz.
 *
 * Beide Listen (Bot-Server, bekannte Server) werden EINMAL geholt und an
 * jede Zeile gereicht; GuildWahl lädt selbst nichts.
 */
export default {
  name: 'DiscordServerZuordnung',
  components: { BaseButton, BaseInfoIcon, ConfirmModal, GuildWahl },
  data() {
    return {
      DISCORD_SERVER,
      SEMESTER_REGEL,
      SERVERWAHL,
      ERKLAERUNG,
      zeilen: [],
      guilds: [],
      bekannte: [],
      botFehler: '',
      // Zähler als :key der GuildWahl je Zeile (s. Template).
      guildsGeladen: 0,
      // Die Zeile, deren Speichern auf Bestätigung wartet (null = keine).
      bestaetigung: null,
      loading: false,
      errorMessage: '',
      successMessage: '',
    };
  },
  computed: {
    // Guild-IDs, die an mehr als einem Credential GESPEICHERT sind.
    mehrfach() {
      const zaehler = new Map();
      for (const z of this.zeilen) {
        if (!z.gespeicherteId) continue;
        zaehler.set(z.gespeicherteId, (zaehler.get(z.gespeicherteId) || 0) + 1);
      }
      return new Set([...zaehler.entries()].filter(([, n]) => n > 1).map(([id]) => id));
    },
    // Der eine Satz im Dialog. Namen statt IDs, wo es welche gibt.
    bestaetigungsSatz() {
      const z = this.bestaetigung;
      if (!z) return '';
      const alt = z.gespeicherterName || z.gespeicherteId;
      return z.entwurf.id
        ? SERVERWAHL.ersetzt(alt, z.entwurf.name || z.entwurf.id)
        : SERVERWAHL.geloest(alt);
    },
  },
  methods: {
    async ladeAlles() {
      this.loading = true;
      this.errorMessage = '';
      try {
        const res = await getAllMicroCredentials();
        this.zeilen = res.data.map((c) => this.zeileAus(c));
      } catch (error) {
        this.errorMessage = error.response?.data?.detail || 'Credentials konnten nicht geladen werden';
      } finally {
        this.loading = false;
      }
      // Die Listen getrennt und NACH den Credentials: sie dürfen scheitern,
      // ohne die Tabelle mitzureißen. Zuerst die bekannten Server (schnell,
      // eigene Datenbank), dann der Bot (läuft gegen MESSAGE_BOT_TIMEOUT).
      await this.ladeBekannte();
      const { guilds, fehler } = await ladeDiscordServer();
      this.guilds = guilds;
      this.botFehler = fehler;
      // Zwingt jede GuildWahl, Liste/Handeingabe mit der geladenen Liste
      // neu zu entscheiden (s. Template).
      this.guildsGeladen += 1;
    },
    async ladeBekannte() {
      const { bekannte } = await ladeBekannteServer();
      this.bekannte = bekannte;
      // Derselbe Riegel wie nach dem Bot: ohne ihn bliebe eine Zeile in der
      // Handeingabe, deren ID erst jetzt in einer Liste steht.
      this.guildsGeladen += 1;
    },
    zeileAus(c) {
      const id = c.discord_guild_id || null;
      const name = c.discord_guild_name || null;
      return {
        id: c.id,
        name: c.name,
        gespeicherteId: id,
        gespeicherterName: name,
        entwurf: { id, name },
        geaendert: false,
        speichert: false,
      };
    },
    setze(zeile, { id, name }) {
      zeile.entwurf = { id, name };
      zeile.geaendert = id !== zeile.gespeicherteId || name !== zeile.gespeicherterName;
    },
    speichern(zeile) {
      this.errorMessage = '';
      this.successMessage = '';
      if (serverwechselBrauchtBestaetigung(zeile.gespeicherteId, zeile.entwurf.id)) {
        this.bestaetigung = zeile;
        return;
      }
      this.schreibe(zeile);
    },
    bestaetigt() {
      const zeile = this.bestaetigung;
      this.bestaetigung = null;
      if (zeile) this.schreibe(zeile);
    },
    // Der PATCH mit BEIDEN Feldern: null löst den Server (weggelassen hieße
    // "bleibt", s. admin.py).
    async schreibe(zeile) {
      zeile.speichert = true;
      try {
        const res = await updateMicroCredential(zeile.id, {
          discord_guild_id: zeile.entwurf.id,
          discord_guild_name: zeile.entwurf.name,
        });
        Object.assign(zeile, this.zeileAus(res.data));
        this.successMessage = `„${zeile.name}“ gespeichert.`;
        // Ein neu gewählter Server steht ab jetzt in der Historie -- die
        // bekannten Server neu holen, damit er dort erscheint.
        await this.ladeBekannte();
      } catch (e) {
        this.errorMessage = e.response?.data?.detail || 'Speichern fehlgeschlagen';
      } finally {
        zeile.speichert = false;
      }
    },
  },
  mounted() {
    // BEWUSST ohne await (wie KategorieWahl): der Bot-Aufruf läuft gegen
    // MESSAGE_BOT_TIMEOUT, und ein await hielte den Tab so lange auf.
    this.ladeAlles();
  },
};
</script>
